export default __webpack_public_path__ + "static/media/signicat-logo.c3292840.png";